import { render, staticRenderFns } from "./OutsideHospitalReportList.vue?vue&type=template&id=2e5bb6ae&scoped=true&"
import script from "./OutsideHospitalReportList.vue?vue&type=script&lang=js&"
export * from "./OutsideHospitalReportList.vue?vue&type=script&lang=js&"
import style0 from "./OutsideHospitalReportList.vue?vue&type=style&index=0&id=2e5bb6ae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5bb6ae",
  null
  
)

export default component.exports